module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "campaign-brief"
    }
  }, [_c('section', {
    staticClass: "content box-columns"
  }, _vm._l((_vm.posts), function(post) {
    return _c('div', {
      key: post.id,
      staticClass: "box insta-box"
    }, [_c('div', {
      staticClass: "box-header with-border"
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": post.influencer.instagram.profilePicture
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(post.influencer.fullName))]), _vm._v(" "), _c('div', {
      staticClass: "location"
    }, [_vm._v(_vm._s(post.location))]), _vm._v(" "), _c('div', {
      staticClass: "tags"
    }, [_vm._v("Tags: " + _vm._s(post.hashtag))]), _vm._v(" "), _c('span', {
      staticClass: "label label-default post-status"
    }, [_vm._v(_vm._s(_vm._f("postStatusText")(post.status)))])]), _vm._v(" "), _c('div', {
      staticClass: "box-body"
    }, [(post.imageURL) ? _c('img', {
      staticClass: "image",
      attrs: {
        "src": post.imageURL
      }
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "text-center",
      staticStyle: {
        "padding-top": "10px"
      }
    }, [_vm._v("No image")]), _vm._v(" "), _c('div', {
      staticClass: "caption"
    }, [_vm._v("\n          " + _vm._s(post.description) + "\n        ")])]), _vm._v(" "), _c('div', {
      staticClass: "box-footer"
    }, [(_vm.canApprove(post.status)) ? _c('button', {
      staticClass: "btn btn-primary btn-sm",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.approvePost(post)
        }
      }
    }, [_vm._v("Approve Post")]) : _vm._e()])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73a52fda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/InfluencerPosts.vue
// module id = 2196
// module chunks = 0